import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
} from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headRows = [
  // { id: 'name', numeric: false, disablePadding: true, label: 'Código' },
  // { id: 'calories', numeric: true, disablePadding: false, label: 'Nome do Banco' },
  // { id: 'fat', numeric: true, disablePadding: false, label: 'PGTO DAM' },
  // { id: 'carbs', numeric: true, disablePadding: false, label: 'PGTO Online' },
  // { id: 'misto', numeric: true, disablePadding: false, label: 'Cadastramento Misto' },

  { id: 'CodigoBanco', numeric: true, disablePadding: true, label: 'Código' },
  { id: 'Descricao', numeric: false, disablePadding: false, label: 'Nome' },
  { id: 'PermiteDAM', numeric: false, disablePadding: true, label: 'Pagamento\xa0DAM'},
  { id: 'PermiteOnline', numeric: false, disablePadding: true, label: 'Pagamento\xa0Online' },
  { id: 'PermiteDebitoAutomatico', numeric: false, disablePadding: true, label: 'Débito\xa0Automático' },
  { id: 'PermiteCadastramentoMisto', numeric: false, disablePadding: true, label: 'Cadastramento\xa0Misto' },
  { id: 'ExigeConfirmacao', numeric: false, disablePadding: true, label: 'Exige\xa0Confirmação' },
  { id: 'FileLogoBanco', numeric: false, disablePadding: true, label: 'Logo' },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell>
        </TableCell>

        {headRows.map(row => (
          <TableCell
            key={row.id}
            align={'left'}
            padding={row.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === row.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              onClick={createSortHandler(row.id)}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  // numSelected: PropTypes.number.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  editIcon: {
    cursor: 'pointer',
  },
}));

export default function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('CodigoBanco');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [banksList, setBanksList] = React.useState([]);
 
  useEffect(() => {
    setBanksList(props.tableFilter.length > 0 ? props.tableFilter : props.tableData)
    setPage(0)    
  }, [props.tableData , props.tableFilter])

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  function handleClick(event, codigo) {
    let banco = banksList.filter(x => x.CodigoBanco === codigo)[0]

    props.navigateToEdit(banco)
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
  }


  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.tableFilter.length <= 0 ? banksList.length : props.tableFilter.length}
            />
            <TableBody>
              {stableSort(props.tableFilter.length > 0 ? props.tableFilter : banksList, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.CodigoBanco}
                    >
                      <TableCell>
                        <Edit onClick={event => handleClick(event, row.CodigoBanco)} className={classes.editIcon}/>
                      </TableCell>
                      {/* <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.Id}
                      </TableCell> */}
                      <TableCell align="left">{row.CodigoBanco}</TableCell>
                      <TableCell align="left">{row.Descricao}</TableCell>
                      <TableCell align="left">{row.PermiteDAM ? "Sim" : "Não"}</TableCell>
                      <TableCell align="left">{row.PermiteOnline ? "Sim" : "Não"}</TableCell>
                      <TableCell align="left">{row.PermiteDebitoAutomatico ? "Sim" : "Não"}</TableCell>
                      <TableCell align="left">{row.PermiteCadastramentoMisto ? "Sim" : "Não"}</TableCell>
                      <TableCell align="left">{row.ExigeConfirmacao ? "Sim" : "Não"}</TableCell>
                      <TableCell align="left">{row.ImagemLogoBanco !== null ? 
                        <CheckRoundedIcon style={{color:"green"}} /> :
                        <ClearIcon color="disabled" />
                      }
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={props.tableFilter.length <= 0 ? banksList.length : props.tableFilter.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage={'Linhas por página:'}
          labelDisplayedRows = {({ from, to, count }) => `${from}-${to === -1 ? count : to} de ${count}`}
          backIconButtonProps={{
            'aria-label': 'Anterior',
          }}
          nextIconButtonProps={{
            'aria-label': 'Próximo',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
